import { render } from "./AIMessageUnit.vue?vue&type=template&id=9fe515a0&scoped=true"
import script from "./AIMessageUnit.vue?vue&type=script&lang=js"
export * from "./AIMessageUnit.vue?vue&type=script&lang=js"

import "./AIMessageUnit.vue?vue&type=style&index=0&id=9fe515a0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fe515a0"]])

export default __exports__